var _excluded = ["href", "title", "children", "style", "className", "target"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useSwiper } from '../../hooks';
import { clsx } from '../../utils';

function Link(props) {
  var _slides$activeIndex$p, _children$props;

  var href = props.href,
      title = props.title,
      children = props.children,
      style = props.style,
      className = props.className,
      target = props.target,
      rest = _objectWithoutProperties(props, _excluded);

  var _useSwiper = useSwiper(),
      slides = _useSwiper.slides,
      activeIndex = _useSwiper.activeIndex;

  var active = ((_slides$activeIndex$p = slides[activeIndex].props) === null || _slides$activeIndex$p === void 0 ? void 0 : _slides$activeIndex$p.src) === (children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.src);
  return /*#__PURE__*/React.createElement("a", _objectSpread({
    href: href,
    title: title,
    target: target,
    style: _objectSpread(_objectSpread({}, style || {}), {}, {
      display: active ? "block" : 'none'
    }),
    className: clsx('nivo-imageLink', 'nivo-slider-link', className)
  }, rest), children);
}

Link.displayName = "Link";
export default Link;